/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Power16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M3.854 3.147a.5.5 0 010 .707C2.696 5.007 2 6.531 2 8.064 2 11.343 4.685 14 8 14s6-2.658 6-5.935c0-1.557-.686-3.062-1.85-4.209a.499.499 0 11.701-.712C14.199 4.47 15 6.228 15 8.064 15 11.897 11.865 15 8 15s-7-3.104-7-6.935c0-1.813.81-3.586 2.147-4.919a.5.5 0 01.707 0zM8 1a.5.5 0 01.5.5v6a.5.5 0 01-1 0v-6A.5.5 0 018 1z"
        />
    </AccessibleSVG>
);

export default Power16;
